// For React.createElement's type
export * from '@tarojs/components/mini'
export const Editor = 'editor'
export const MatchMedia = 'match-media'
export const FunctionalPageNavigator = 'functional-page-navigator'
export const LivePusher = 'live-pusher'
export const OfficialAccount = 'official-account'
export const OpenData = 'open-data'
export const NavigationBar = 'navigation-bar'
export const PageMeta = 'page-meta'
export const VoipRoom = 'voip-room'
export const AdCustom = 'ad-custom'
export const PageContainer = 'page-container'
export const KeyboardAccessory = 'keyboard-accessory'
